import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { t } from 'ember-intl';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import Actions from './actions';
import Filters from './filters';
import Search from './search';
import styles from './styles.module.css';

const bem = getBem(styles);
export default class RecordExplorerToolbarComponent extends Component {
  // Getter and setter
  get hasFilterOrSearch() {
    let hasActiveFilters = Object.keys(this.args.activeFilters);

    return this.args.searchString || hasActiveFilters;
  }

  // Functions
  clearFilterAndSearch = () => {
    let filters = this.args.activeFilters;

    Object.keys(filters).forEach((key) => {
      delete filters[key];
    });

    this.args.onSearch('');
    this.args.onSetFilter('filters', filters);
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <div class={{bem 'filters'}}>
        <Search
          @recordType={{@recordType}}
          @onSearch={{@onSearch}}
          @searchString={{@searchString}}
        />

        <Filters
          @activeFilters={{@activeFilters}}
          @availableFilters={{@availableFilters}}
          @recordType={{@recordType}}
          @onChangeFilter={{fn @onSetFilter 'filters'}}
        />
      </div>

      <div class={{bem 'reset'}}>
        {{#if this.hasFilterOrSearch}}
          <Button
            @icon='close'
            @style='danger'
            @tooltip={{t 'record_explorer.toolbar.reset'}}
            {{on 'click' this.clearFilterAndSearch}}
          />
        {{/if}}
      </div>

      <div class={{bem 'actions'}}>
        <Actions
          @activeColumns={{@activeColumns}}
          @columns={{@columns}}
          @recordType={{@recordType}}
          @onAddRecord={{@onAddRecord}}
          @onAssignRelation={{@onAssignRelation}}
          @onChangeColumns={{fn @onSetFilter 'columns'}}
          @parentRecordType={{@parentRecordType}}
          @selectedRecords={{@selectedRecords}}
        >
          {{#if (has-block 'actions')}}
            {{yield to='actions'}}
          {{/if}}
        </Actions>
      </div>
    </div>
  </template>
}
